import type { CardAttributeCopyDto } from "../../types/CardAttributeCopyDto";
import type { CardAttributeCopyEntity } from "../../types/CardAttributeCopyEntity";

export const CardAttributeCopyEntityToCopyDto = ({ ...rest }: Readonly<CardAttributeCopyEntity>): CardAttributeCopyDto => {
    return { ...rest };
};
